"use client";
import { CldVideoPlayer } from "next-cloudinary";
import "next-cloudinary/dist/cld-video-player.css";
import { useEffect, useRef } from "react";

function Video() {
  // widthViewPort = useRef(window.innerWidth);

  // useEffect(() => {

  return (
    <>
      {/* <img
        src="/poster_video.webp"
        className="aspect-video w-full bg-slate-500 md:col-start-2 md:row-span-4 md:row-start-1 md:row-end-5"
      /> */}
      <div className="aspect-video w-full bg-slate-500 bg-[url('/poster_video.webp')] md:col-start-2 md:row-span-4 md:row-start-1 md:row-end-5">
        <CldVideoPlayer
          id="matej_video_1_csvvqb"
          width="620"
          height="348"
          src="matej_video_1_csvvqb"
          posterOptions={{
            transformation: { start_offset: 0 },
          }}
        />
      </div>
    </>
  );
}

export default Video;
// src="matej_video_1_csvvqb"
